import { Card, Colors, Icon, Text } from '@amelio/ui-library';
import { Trans } from 'react-i18next';

/**
 * Says, before the manager writes the context, what it is for: once the plan is generated, the AI turns
 * it into the meeting's agenda. The purple border and the sparkles mark it as the AI's part of the flow.
 */
export const ContextAiNotice = () => {
    return (
        <Card
            padding={'sm'}
            borderRadius={'lg'}
            borderColor={Colors.AI_PURPLE}
            bgColor={'bg-white/60'}
        >
            <div className={'flex items-center gap-3'}>
                <Icon
                    name={'lucide-sparkles'}
                    size={'xl'}
                    color={Colors.AI_PURPLE}
                    // Without it the row's text squeezes the sparkles narrower than it is tall,
                    // which draws the glyph smaller than the size asked for.
                    className={'shrink-0'}
                    ariaHidden
                />

                <Text
                    size={'small'}
                    color={Colors.NAVY}
                >
                    <Trans
                        i18nKey={'thematicMeetings.newMeeting.aiAssistantNotice'}
                        components={{
                            // The assistant's name carries the AI gradient, so the feature reads as
                            // its own voice rather than as one more bold word.
                            bold: (
                                <span
                                    className={
                                        'from-ai-purple to-ai-pink bg-linear-to-r bg-clip-text font-semibold text-transparent'
                                    }
                                />
                            ),
                        }}
                    />
                </Text>
            </div>
        </Card>
    );
};
